module.exports = __webpack_public_path__ + "static/media/front-left.e117ecc2.jpg";